var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
export var filterProps = function (_a) {
    var registerAsChild = _a.registerAsChild, onUnmount = _a.onUnmount, Component = _a.Component, pose = _a.pose, initialPose = _a.initialPose, Key = _a.Key, draggable = _a.draggable, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, factoryConfig = _a.factoryConfig, poseConfig = _a.poseConfig, flipMove = _a.flipMove, popFromLayout = _a.popFromLayout, props = __rest(_a, ["registerAsChild", "onUnmount", "Component", "pose", "initialPose", "Key", "draggable", "onDragStart", "onDragEnd", "factoryConfig", "poseConfig", "flipMove", "popFromLayout"]);
    return props;
};
export var hasChanged = function (prev, next) {
    if (prev === next)
        return false;
    var prevIsArray = Array.isArray(prev);
    var nextIsArray = Array.isArray(next);
    if (prevIsArray !== nextIsArray || (!prevIsArray && !nextIsArray)) {
        return true;
    }
    else if (prevIsArray && nextIsArray) {
        var numPrev = prev.length;
        var numNext = next.length;
        if (numPrev !== numNext)
            return true;
        for (var i = 0; i < numPrev; i++) {
            if (prev[i] !== next[i])
                return true;
        }
    }
    return false;
};
//# sourceMappingURL=utils.js.map